import { SearchAgreementsFilterField } from "$apis/parkito";

export enum AgreementStatus {
  DRAFT = "draft",
  OFFERED = "offered",
  OFFER_EXPIRED = "offerExpired",
  OFFER_DECLINED = "offerDeclined",
  APPROVED = "approved",
  ACTIVE = "active",
  ENDING = "ending",
  ENDED = "ended",
}

export type AgreementStatusType =
  | "draft"
  | "offered"
  | "offerExpired"
  | "offerDeclined"
  | "approved"
  | "active"
  | "ending"
  | "ended";

export function agreementStatusToSearchAgreementFilters(
  status: AgreementStatusType,
): SearchAgreementsFilterField[] {
  switch (status) {
    case "draft":
      return [SearchAgreementsFilterField.DRAFT];
    case "offered":
      return [SearchAgreementsFilterField.OFFERED];
    case "offerExpired":
      return [SearchAgreementsFilterField.OFFER_EXPIRED];
    case "offerDeclined":
      return [SearchAgreementsFilterField.OFFER_DECLINED];
    case "approved":
      return [SearchAgreementsFilterField.APPROVED];
    case "active":
      return [SearchAgreementsFilterField.ACTIVE];
    case "ending":
      return [SearchAgreementsFilterField.ENDING];
    case "ended":
      return [SearchAgreementsFilterField.ENDED];
  }
}
